<section>
    <ng-container *ngFor="let step of steps">
        <div class="step">
            <ng-container [ngTemplateOutlet]="step.content"></ng-container>
        </div>
    </ng-container>
</section>
